export const ADD_ABOUTUS_SUCCESS = "aboutus/create_aboutus_success";
export const ADD_ABOUTUS_FAIL = "aboutus/create_aboutus_fail";

export const UPDATE_ABOUTUS_SUCCESS = "aboutus/update_aboutus_success";
export const UPDATE_ABOUTUS_FAIL = "aboutus/update_aboutus_fail";

export const GET_ABOUTUS_SUCCESS = "aboutus/get_aboutus_success";
export const GET_ABOUTUS_FAIL = "aboutus/get_aboutus_fail";

export const DELETE_ABOUTUS_SUCCESS = "aboutus/delete_aboutus_success";
export const DELETE_ABOUTUS_FAIL = "aboutus/delete_aboutus_fail";